import { createAsyncThunk } from "@reduxjs/toolkit";
import { GETAPIREQUEST } from "../util";

const GET_PLAN_DETAILS =
  "https://web1024.docmaster.in:5010/api/subscriptionmodel";

// const INITIATE_PAYMENT = "https://web1024.docmaster.in:5004/school_payment_form";
const INITIATE_PAYMENT = "https://web1024.docmaster.in:5004/school_pg_payment_form";

export const GetPaymentPlanDetailsThunk = createAsyncThunk(
  "PaymentGateway/GetPaymentPlanDetails",
  async (_, { rejectWithValue }) => {
    return GETAPIREQUEST(GET_PLAN_DETAILS, "Plan Details", rejectWithValue);
  }
);

export const InitiatePaymentThunk = createAsyncThunk(
  "PaymentGateway/InitiatePaymentThunk",
  async (body, { rejectWithValue }) => {
    try {
      if (!body?.amount || body.amount <= 0) {
        return rejectWithValue("Invalid payment amount");
      }

      const form = document.createElement("form");
      form.method = "POST";
      form.action = INITIATE_PAYMENT;

      Object.keys(body).forEach((key) => {
        const input = document.createElement("input");
        input.type = "hidden";
        input.name = key;
        input.value = body[key];
        form.appendChild(input);
      });

      document.body.appendChild(form);
      form.submit();
    } catch (err) {
      return rejectWithValue("Failed to initiate payment");
    }
  }
);
